import React, { useState, useEffect } from 'react';
import "./RelaysCTOne.css";
import RelaysCTTwo from "./RelaysCTTwo";
import CreateReport from "./CreateReport";
import { API_URL } from './API';



const clearAllRelatedStorage = () => {
  const keysToRemove = [
    'relayTestData',
    'relayCurrentMeasurements',
    'relayVoltageMeasurements',
    'relaySettings',
    'relayCTOperationalTimeData',
    'functionalChecksData',
    'checkListData',
    'relaysCTFormData',
    'relaysCTRowsData',
    'relaysCT_autosave',
    'formSubmissionStatus',
    'wordDocDownloadStatus',
    'reportCreationCompleted',
    'lastCompletionTimestamp'
  ];
  
  keysToRemove.forEach(key => localStorage.removeItem(key));
};


const RelayTestForm = ({ block, plant, instrument, project, goBack }) => {
  const [showNextPage, setShowNextPage] = useState(false);
 

  const fetchClientName = async (clientId) => {
    try {
      const response = await fetch(`${API_URL}/clients/get_client`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
      });
      
      if (response.ok) {
        const result = await response.json();
        let clientsData = Array.isArray(result) ? result : result.data || result.clients || [];
        const client = clientsData.find(c => c.client_id === clientId || c.id === clientId);
        return client ? client.client_name : "Unknown Client";
      }
    } catch (error) {
      
    }
    return "Unknown Client";
  };






const [formData, setFormData] = useState(() => {
  const downloadComplete = localStorage.getItem('wordDocDownloadStatus') === 'completed';
  
  if (downloadComplete) {
    clearAllRelatedStorage();
    return {
      description: 'NUMERICAL RELAY INSPECTION (CT) / TEST REPORT',
      date: '',
      customer: '',
      project: '',
      reportNo: '',
      location: '',
      client: '',
      make: '',
      type: '',
      ctRatio: '',
      supplyVoltage: '',
      serialNo: '',
      vtRatio: ''
    };
  }
  
  const savedData = localStorage.getItem('relayTestData');
  return savedData ? JSON.parse(savedData) : {
    description: 'NUMERICAL RELAY INSPECTION (CT) / TEST REPORT',
    date: '',
    customer: '',
    project: '',
    reportNo: '',
    location: '',
    client: '',
    make: '',
    type: '',
    ctRatio: '',
    supplyVoltage: '',
    serialNo: '',
    vtRatio: ''
  };
});


  const [rows, setRows] = useState([]);
  const [generalInspection, setGeneralInspection] = useState({});

  useEffect(() => {
    localStorage.setItem('relayTestData', JSON.stringify(formData));
  }, [formData]);

  useEffect(() => {
    const loadProjectData = async () => {
      if (project) {
        let clientName = project?.clientName || project?.client_name;
        
        if (!clientName && project?.client) {
          clientName = await fetchClientName(project.client);
        }
        
        setFormData(prevData => ({
          ...prevData,
          project: project?.name || '',
          client: clientName || '',
          
        }));
      }
    };
    
    loadProjectData();
  }, [project]);

  useEffect(() => {
    const autoSaveInterval = setInterval(() => {
      localStorage.setItem('relayTestData', JSON.stringify(formData));
    }, 5000);

    return () => clearInterval(autoSaveInterval);
  }, [formData]);

  const validateInput = (name, value) => {
    switch (name) {
      case 'description':
        return value.replace(/[^a-zA-Z\s/ ]/g, '');

      case 'customer':
      case 'client':
        return value.replace(/[^a-zA-Z\s ]/g, '');

      case 'project':
        return value.replace(/[^a-zA-Z0-9, ]/g, '');
      
      case 'reportNo':
        return value.replace(/[^a-zA-Z0-9- ()]/g, '');

      case 'location':
        return value.replace(/[^a-zA-Z0-9-, ()]/g, '');
      
      case 'make':
        return value.replace(/[^a-zA-Z0-9\s ]/g, '');
      
      case 'type':
      case 'supplyVoltage':
      case 'serialNo':
        return value.replace(/[^a-zA-Z0-9/, ]/g, '');
      
      case 'ctRatio':
      case 'vtRatio':
        return value.replace(/[^a-zA-Z0-9/ ]/g, '');
      
      default:
        return value;
    }
  };

  const redirectToHome = () => {
    if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {  
      localStorage.setItem('openReportsOnLoad', 'true');
      window.location.href = "/";
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validatedValue = validateInput(name, value);
    setFormData(prev => ({ ...prev, [name]: validatedValue }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
  };

  const handleBack = () => {
  localStorage.setItem('relayTestData', JSON.stringify(formData));
  if (goBack) {
    goBack();
  }
};
  
  const handleNext = (e) => {
    e.preventDefault();
    setShowNextPage(true);
  };

 

  if (showNextPage) {
    return <RelaysCTTwo 
      goBack={() => setShowNextPage(false)} 
      savedGeneralData={{
        formData,
        rows,
        generalInspection
      }} 
    />;
  }

  return (
    <div>
      <form className="rt-1001" onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 className="rt-1002">NUMERICAL RELAY INSPECTION / TEST REPORT(CT/VT)</h2>
          <span 
            style={{ 
              display: 'flex',
              justifyContent: 'flex-end',
              fontSize: '20px', 
              fontWeight: '600', 
              color: '#333', 
              cursor: 'pointer',
              marginLeft: '50px',
              marginBottom: '50px'
            }}
            onClick={redirectToHome}
          >
            X
          </span>
        </div>
        
        <div className="rt-1003">
          <div className="rt-1004">
            <label className="rt-1005">Description</label>
            <input 
              name="description" 
              value="NUMERICAL RELAY INSPECTION (CT) / TEST REPORT"
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Description' 
              readOnly
              style={{ cursor: 'not-allowed' }}
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Date</label>
            <input 
              type="date" 
              name="date" 
              value={formData.date || ''} 
              onChange={handleChange} 
              className="rt-1006" 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Customer</label>
            <input 
              name="customer" 
              value={formData.customer || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Customer' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Project</label>
            <input 
              name="project" 
              value={formData.project || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Project' 
              readOnly
              style={{ cursor: 'not-allowed' }}
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Report No</label>
            <input 
              name="reportNo" 
              value={formData.reportNo || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Report No' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Location</label>
            <input 
              name="location" 
              value={formData.location || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Location' 
             
            />
          </div>
          <div className="rt-1004 rt-1007">
            <label className="rt-1005">Client</label>
            <input 
              name="client" 
              value={formData.client || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Client' 
              readOnly
              style={{ cursor: 'not-allowed' }}
            />
          </div>
        </div>

        <h3 className="rt-1008">NAME PLATE DETAILS</h3>
        <div className="rt-1003">
          <div className="rt-1004">
            <label className="rt-1005">Make</label>
            <input 
              name="make" 
              value={formData.make || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Make' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Type</label>
            <input 
              name="type" 
              value={formData.type || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Type' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">CT Ratio</label>
            <input 
              name="ctRatio" 
              value={formData.ctRatio || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter CT Ratio' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Supply Voltage (Uaux)</label>
            <input 
              name="supplyVoltage" 
              value={formData.supplyVoltage || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Enter Supply Voltage' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">Serial No</label>
            <input 
              name="serialNo" 
              value={formData.serialNo || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='Serial No' 
            />
          </div>
          <div className="rt-1004">
            <label className="rt-1005">VT Ratio</label>
            <input 
              name="vtRatio" 
              value={formData.vtRatio || ''} 
              maxLength={40}
              onChange={handleChange} 
              className="rt-1006" 
              placeholder='VT Ratio' 
            />
          </div>
        </div>
      
        <div className="button-group">
          <button type="button" onClick={handleBack}>Back</button>
          <button type="button" className="nxt1" onClick={handleNext}>Next</button>
        </div>
      </form>
    </div>
  );
};

export default RelayTestForm;